import React, { FC, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';

import { NoPermission } from '~/components';
import { PageList } from '~/layout';
import { Payroll } from '~/types';
import Filters from './view/Filters';
import PayrollsTable from './view/PayrollsTable';
import PayrollShow from './view/PayrollShow';
import PayrollCreateButton from '~/pages/payrolls/create/PayrollCreateButton';
import GuideDrawer from '~/pages/payrolls/components/GuideDrawer';
import useDisclose from '~/hooks/useDisclose';
import { usePermissions } from '~/hooks';
import PayrollHeader from '~/pages/payrolls/create/PayrollHeader';

const Payrolls: FC<RouteComponentProps> = () => {
  const [openPayrollDetail, setOpenPayrollDetail] = useState(false);
  const [showData, setShowData] = useState<Payroll | null>(null);
  const handleOpen = (payroll: Payroll) => {
    setOpenPayrollDetail(true);
    setShowData(payroll);
  };
  const handleClose = () => {
    setOpenPayrollDetail(false);
  };

  const { isOpen: isGuideOpen, onOpen: opedGuide, onClose: closeGuide } = useDisclose(false);

  const hasAccess = usePermissions('business.payrolls.list');
  if (!hasAccess) return <NoPermission />;
  return (
    <>
      <GuideDrawer open={isGuideOpen} onClose={closeGuide} />
      <PayrollShow open={openPayrollDetail} data={showData} onClose={handleClose} />
      <PageList
        header={{
          heading: <PayrollHeader onClick={opedGuide} />,
          showSearch: false,
        }}
        filters={<Filters />}
        table={<PayrollsTable handleOpen={handleOpen} />}
        hideDisplayMode
        add={<PayrollCreateButton />}
      />
    </>
  );
};

export const payrollResourceKey = 'payrolls';

export default Payrolls;
